import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmPhoneVerificationIncorrectCodeError } from '@/core/error/transport/customErrors/tmPhoneVerificationIncorrectCodeError'

export const phoneVerificationIncorrectCodeErrorRule: CustomErrorRule = {
  endpoint: EndpointsEnum.checkVerifyCodeOnPhone,
  subCodes: ['user.verification.invalid_code'],
  klass: TmPhoneVerificationIncorrectCodeError,
}
